import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { SincronizarToken } from "./components/Sesion";
import "./index.css";
import { authConfig } from "./lib/auth";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("Falta el elemento #root en index.html");

createRoot(container).render(
  <StrictMode>
    {/* El orden importa: la sesión envuelve todo, y `SincronizarToken` mantiene
        al día el token que usa el cliente de la API, que vive fuera de React. */}
    <AuthProvider {...authConfig}>
      <SincronizarToken>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </SincronizarToken>
    </AuthProvider>
  </StrictMode>,
);
